import '@/assets/styles/main.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vSelect from 'vue-select'
import VeeValidate from 'vee-validate'
import validateLocale from './validate-locale.js'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import '@/assets/styles/picker.css'
import 'vue2-datepicker/locale/ru';
import VModal from 'vue-js-modal'
import store from './store'
import http from './http'
import DatePicker from 'vue2-datepicker';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import TreeRoot from "@/components/tree/components/TreeRoot";
import VueEllipseProgress from 'vue-ellipse-progress';
import clickOutside from '@/directives/click-outside';
import VueAgile from 'vue-agile';
import VueCurrencyFilter from 'vue-currency-filter';
import rate from 'vue-rate';
import YmapPlugin from 'vue-yandex-maps'
import StarRating from 'vue-dynamic-star-rating'
import moment from 'moment-timezone'
import {VueMasonryPlugin} from 'vue-masonry';
import VWave from 'v-wave'
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use(CKEditor)
Vue.use(VWave,{
    directive: 'ripple'
})
Vue.use(VueAgile)
Vue.use(VueEllipseProgress);
Vue.use(CoolLightBox);
Vue.use(VModal);
Vue.use(VeeValidate, validateLocale);
Vue.use(Toast, {});
Vue.use(rate);
Vue.use(StarRating);
Vue.use(VueCurrencyFilter,
    {
        symbol : '',
        thousandsSeparator: ' ',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: true,
        avoidEmptyDecimals: undefined,
    })
Vue.use(YmapPlugin, {
    apiKey: process.env.VUE_APP_YANDEX_MAPS_API_KEY,
    lang: 'ru_RU',
    coordorder: 'latlong',
    version: '2.1.77'
})
Vue.use(VueMasonryPlugin)

DatePicker.props.lang.default = 'ru';
DatePicker.props.format.default="DD.MM.YYYY";
DatePicker.props.valueType.default="YYYY-MM-DD";
moment.locale('ru')

Vue.component('date-picker', DatePicker);
Vue.component('v-select', vSelect);
Vue.component('tree', TreeRoot);

Vue.config.productionTip = false;
Vue.prototype.$http = http;
Vue.prototype.$moment = moment;

Vue.directive('click-outside', clickOutside);

Vue.mixin({
  methods: {
    can: function (permission) {
        if (permission) {
            let arr = this.$store.getters.getCompany.permissions;
            return arr.includes(permission);
        }
        return true;
    },
  },
})

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')

console.log(
    `%c Developed by %c @plagov %c`,
    'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
    'background:#2CB181 ; padding: 1px; border-radius: 0 3px 3px 0; color: #fff',
    'background:transparent'
)
